module.exports = __webpack_public_path__ + "static/media/sf_2400_gray.850fd9c39aa8baf68fa56ca0a0dc1f11.png";